/* LX shared behaviours */
(function () {
  'use strict';

  /* ---- slider ---- */
  class LxSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.lx-slider__viewport');
      this.track = this.querySelector('.lx-slider__track');
      this.items = Array.from(this.track.children);
      this.prev = this.querySelector('[data-lx-prev]');
      this.next = this.querySelector('[data-lx-next]');
      this.dots = this.querySelector('[data-lx-dots]');
      this.perMove = parseInt(this.dataset.perMove || '1', 10);
      this.autoplay = parseInt(this.dataset.autoplay || '0', 10);
      this.loop = this.dataset.loop === '1';
      if (!this.items.length) return;
      this.prev && this.prev.addEventListener('click', () => this.go(-1));
      this.next && this.next.addEventListener('click', () => this.go(1));
      this.buildDots();
      this.viewport.addEventListener('scroll', () => { clearTimeout(this._t); this._t = setTimeout(() => this.update(), 80); }, { passive: true });
      window.addEventListener('resize', () => { this.buildDots(); this.update(); });
      this.update();
      if (this.autoplay > 0) this.startAuto();
    }
    isSlider() { return getComputedStyle(this.track).display === 'flex'; }
    itemWidth() { const it = this.items[0]; return it.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0); }
    pageCount() {
      if (!this.isSlider()) return 1;
      const vis = Math.max(1, Math.round(this.viewport.clientWidth / this.itemWidth()));
      return Math.max(1, this.items.length - vis + 1);
    }
    index() { return this.isSlider() ? Math.round(this.viewport.scrollLeft / this.itemWidth()) : 0; }
    buildDots() {
      if (!this.dots) return;
      const n = this.pageCount();
      if (this.dots.childElementCount === n) return;
      this.dots.innerHTML = '';
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', () => this.to(i)); this.dots.appendChild(b);
      }
    }
    to(i) { this.viewport.scrollTo({ left: i * this.itemWidth(), behavior: 'smooth' }); }
    go(dir) {
      const n = this.pageCount(); let i = this.index() + dir * this.perMove;
      if (i >= n) i = this.loop ? 0 : n - 1;
      if (i < 0) i = this.loop ? n - 1 : 0;
      this.to(i);
    }
    update() {
      const i = this.index(), n = this.pageCount();
      if (this.dots) Array.from(this.dots.children).forEach((d, k) => k === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current'));
      if (!this.loop) { this.prev && (this.prev.disabled = i <= 0); this.next && (this.next.disabled = i >= n - 1); }
    }
    startAuto() {
      const tick = () => { if (!this.matches(':hover') && this.isSlider()) this.go(1); };
      this._auto = setInterval(tick, this.autoplay);
    }
  }
  if (!customElements.get('lx-slider')) customElements.define('lx-slider', LxSlider);

  /* ---- before / after ---- */
  class LxCompare extends HTMLElement {
    connectedCallback() {
      const before = this.querySelector('.lx-cmp__before'), handle = this.querySelector('.lx-cmp__handle'), range = this.querySelector('.lx-cmp__range');
      const img = before && before.querySelector('img');
      const size = () => { if (img) img.style.width = this.clientWidth + 'px'; };
      const set = (v) => { before.style.width = v + '%'; handle.style.left = v + '%'; };
      size(); window.addEventListener('resize', size);
      if (img && !img.complete) img.addEventListener('load', size);
      range.addEventListener('input', () => set(range.value));
      set(50);
    }
  }
  if (!customElements.get('lx-compare')) customElements.define('lx-compare', LxCompare);

  /* ---- video with play/sound ---- */
  class LxVideo extends HTMLElement {
    connectedCallback() {
      const v = this.querySelector('video'); if (!v) return;
      const play = this.querySelector('.lx-video__play'), sound = this.querySelector('.lx-video__sound');
      this.classList.add('lx-video--muted');
      if (v.autoplay) { this.classList.add('lx-video--playing'); v.play().catch(() => {}); }
      const toggle = () => { if (v.paused) { v.play(); this.classList.add('lx-video--playing'); } else { v.pause(); this.classList.remove('lx-video--playing'); } };
      play && play.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      sound && sound.addEventListener('click', (e) => { e.stopPropagation(); v.muted = !v.muted; this.classList.toggle('lx-video--muted', v.muted); });
    }
  }
  if (!customElements.get('lx-video')) customElements.define('lx-video', LxVideo);

  /* ---- shipping timeline dates ---- */
  class LxShipping extends HTMLElement {
    connectedCallback() {
      const days = (this.dataset.days || 'Mon, Tue, Wed, Thu, Fri, Sat, Sun').split(',').map(s => s.trim());
      const months = (this.dataset.months || 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec').split(',').map(s => s.trim());
      const fmt = this.dataset.format || 'dd_mm';
      const f = (d) => {
        const dd = d.getDate(), mm = months[d.getMonth()] || '', dn = days[(d.getDay() + 6) % 7] || '';
        if (fmt === 'mm_dd') return mm + ' ' + dd;
        if (fmt === 'day_dd_mm') return dn + ' ' + dd + ' ' + mm;
        if (fmt === 'dd_mm_no_dot') return dd + ' ' + mm;
        return dd + '. ' + mm;
      };
      const add = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
      this.querySelectorAll('.lx-ship__step').forEach(step => {
        const min = parseInt(step.dataset.min || '0', 10), max = parseInt(step.dataset.max || '0', 10);
        const top = step.querySelector('.lx-ship__top');
        const tpl = top.dataset.lxTemplate || top.innerHTML;
        top.innerHTML = tpl.replace(/\[start_date\]/g, f(add(min))).replace(/\[end_date\]/g, f(add(max)));
      });
    }
  }
  if (!customElements.get('lx-shipping')) customElements.define('lx-shipping', LxShipping);

  /* ---- sticky add to cart ---- */
  class LxStickyAtc extends HTMLElement {
    connectedCallback() {
      /* escape any transformed/overflow ancestor so position:fixed uses the viewport */
      if (this.parentElement !== document.body) {
        document.body.querySelectorAll(':scope > lx-sticky-atc').forEach((o) => { if (o !== this) o.remove(); });
        document.body.appendChild(this);
        return;
      }
      if (this._lxInit) return;
      this._lxInit = true;
      document.body.classList.add('lx-has-sticky');
      const target = document.querySelector(this.dataset.target) || document.querySelector('.product-form__submit');
      const btn = this.querySelector('.lx-sticky__btn');
      btn && btn.addEventListener('click', () => { if (target) { target.click(); } });
      if (this.dataset.when === 'always' || !target) { this.classList.add('lx-sticky--visible'); return; }
      const update = () => { this.classList.toggle('lx-sticky--visible', target.getBoundingClientRect().bottom < 0); };
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
    }
  }
  if (!customElements.get('lx-sticky-atc')) customElements.define('lx-sticky-atc', LxStickyAtc);

  /* ---- scroll-to for stars, animated bars/counters ---- */
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-lx-scroll]'); if (!el) return;
    const t = document.querySelector(el.dataset.lxScroll); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll('.lx-results__fill').forEach(f => f.style.width = f.style.getPropertyValue('--lx-w'));
      e.target.querySelectorAll('[data-lx-count]').forEach(c => {
        const end = parseInt(c.dataset.lxCount, 10), t0 = performance.now();
        const step = (t) => { const p = Math.min(1, (t - t0) / 1200); c.textContent = Math.round(end * p); if (p < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      });
      io.unobserve(e.target);
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.lx-results').forEach(r => { r.querySelectorAll('.lx-results__fill').forEach(f => f.style.width = '0'); io.observe(r); });
})();

/* cart drawer countdown timer */
if (!customElements.get('lx-cart-timer')) {
  customElements.define('lx-cart-timer', class extends HTMLElement {
    connectedCallback() {
      var total = parseInt(this.dataset.seconds || '300', 10);
      var tpl = this.dataset.template || '[timer]';
      var el = this.querySelector('.lx-cart-timer__text');
      var key = 'lxCartTimer';
      var end;
      try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
      var now = Date.now();
      if (!end || end < now || end - now > total * 1000) {
        end = now + total * 1000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      var self = this;
      var tick = function () {
        var left = Math.max(0, Math.round((end - Date.now()) / 1000));
        var m = Math.floor(left / 60), s = left % 60;
        var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (el) el.innerHTML = tpl.split('[timer]').join(txt);
        if (left <= 0) {
          clearInterval(self._t);
          try { sessionStorage.removeItem(key); } catch (e) {}
        }
      };
      tick();
      this._t = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this._t); }
  });
}

/* cart drawer discount field */
if (!customElements.get('lx-cart-discount')) {
  customElements.define('lx-cart-discount', class extends HTMLElement {
    connectedCallback() {
      var input = this.querySelector('.lx-cdisc__input');
      var btn = this.querySelector('.lx-cdisc__btn');
      var err = this.querySelector('.lx-cdisc__err');
      if (!input || !btn) return;
      var go = function () {
        var code = (input.value || '').trim();
        if (!code) {
          if (err) { err.textContent = this.dataset.error || ''; err.hidden = false; }
          return;
        }
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      }.bind(this);
      btn.addEventListener('click', go);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    }
  });
}

/* cart drawer custom body background */
document.addEventListener('DOMContentLoaded', function () {
  var apply = function () {
    document.querySelectorAll('[data-lx-bodybg]').forEach(function (el) {
      var c = el.getAttribute('data-lx-bodybg');
      if (c) el.style.setProperty('background-color', c);
    });
  };
  apply();
  document.addEventListener('shopify:section:load', apply);
});
